export enum DigitalLibraryItemTypes {
    Template = 'Template',
    Product = 'Product',
    None = 'None'
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/enum/digitalLibraryItemTypes.enum.ts